export default __webpack_public_path__ + "static/Contact1-34176173ca5e7d01e96e35d6f98da4ac.webp";